const getOptions = (_status: string) => {

    const options = {
        ME: [
            {
                label: 'Movement Enquiry',
                value: 'MovementEnquiry',
                SelectionDisabled: true,
                children: [
                    {
                        label: 'Movement Details',
                        value: 'MovementEnquiryDetails',
                        disabled: false,
                    },
                    {
                        label: 'Transactions',
                        value: 'Transactions',
                        disabled: false,
                    },
                    {
                        label: 'Bin Locations',
                        value: 'BinLocations',
                        disabled: false,
                    },
                    {
                        label: 'Lot Details',
                        value: 'LotDetails',
                        disabled: false,
                    },
                    {
                        label: 'Serial Numbers',
                        value: 'SerialNumbers',
                        disabled: false,
                    },
                ]
            }
        ]
    };

    return options;
};

export default getOptions;
